import Cookies from 'js-cookie'

import { COOKIE_KEYS } from '@/lib/configs/auth-config'
import { randomUUID } from '@/lib/utils'

// device_id lives and dies with the refresh token (backend session-security
// contract) — same 7-day TTL as REFRESH_TOKEN_MAX_AGE in the session route.
const DEVICE_ID_TTL_DAYS = 7

export function getOrCreateDeviceId(): string {
  const existing = Cookies.get(COOKIE_KEYS.DEVICE_ID)
  if (existing) return existing
  const id = randomUUID()
  Cookies.set(COOKIE_KEYS.DEVICE_ID, id, {
    expires: DEVICE_ID_TTL_DAYS,
    path: '/',
    sameSite: 'lax',
    secure:
      process.env.NODE_ENV === 'production' &&
      typeof window !== 'undefined' &&
      window.location.hostname !== 'localhost',
  })
  return id
}

export function clearDeviceId(): void {
  Cookies.remove(COOKIE_KEYS.DEVICE_ID, { path: '/' })
}
